var render = function render(){var _vm=this,_c=_vm._self._c;return _c('GenericDrawer',{attrs:{"colorKey":"bgDrawerContent","isSubDrawer":true,"isOpen":true,"topLinks":_vm.topLinks},scopedSlots:_vm._u([{key:"prepend",fn:function(){return [_c('v-list-item',[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v("Naviguation")])],1)],1),_c('v-divider')]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }